import { User } from "../types/user";

/**
 * Mock user list — no user-management API exists yet (see BE-6 in
 * docs/backend-api-requirements.md). Sourced from
 * act-si-console/src/components/user/usermock.js so the placeholder data is
 * consistent with the rest of the ACT product fleet. Swap `fetchUsers` for a
 * real `apiClient.get` call once the endpoint is ready — the rest of the
 * page/hook contract stays the same.
 */
const USER_MOCK: User[] = [
  {
    id: 1,
    name: "Jamie Garrow-Fisher",
    firstName: "Jamie",
    lastName: "Garrow-Fisher",
    email: "jamie@fantastic.tech",
    role: "Admin",
    date: "02/23/2025 18:46:16",
    sessions: "06/30/2025 15:24:03",
    permissions: "Admin",
    device: "Web",
    address: "Brighton, UK",
    createdAt: "09/23/2025 12:11:45",
  },
  {
    id: 2,
    name: "Graeme Kay",
    firstName: "Graeme",
    lastName: "Kay",
    email: "graeme@fantastic.tech",
    role: "Tech Support",
    date: "07/25/2025 07:44:13",
    sessions: "09/22/2025 09:40:33",
    permissions: "Admin",
    device: "Web",
    address: "Brighton, UK",
    createdAt: "07/25/2025 12:34:51",
  },
  {
    id: 3,
    name: "Ghufran Khan",
    firstName: "Ghufran",
    lastName: "Khan",
    email: "ghufran@fantastic.tech",
    role: "Analyst",
    date: "06/10/2025 10:45:12",
    sessions: "09/22/2025 09:10:11",
    permissions: "Admin",
    device: "Web",
    address: "Brighton, UK",
    createdAt: "06/10/2025 07:23:46",
  },
  {
    id: 4,
    name: "Miguel Lopez",
    firstName: "Miguel",
    lastName: "Lopez",
    email: "lopez1@prodigy.net.mx",
    role: "Analyst",
    date: "02/05/2025 16:31:23",
    sessions: "09/21/2025 11:59:24",
    permissions: "Analyst",
    device: "Web",
    address: "Mexico",
    createdAt: "08/28/2025 10:19:56",
  },
  {
    id: 5,
    name: "Cristi Radulescu",
    firstName: "Cristi",
    lastName: "Radulescu",
    email: "cr@theecho.ro",
    role: "Analyst",
    date: "07/10/2025 08:25:12",
    sessions: "09/12/2025 09:05:55",
    permissions: "Admin",
    device: "Web",
    address: "Bucharest, Romania",
    createdAt: "07/10/2025 17:54:21",
  },
  {
    id: 6,
    name: "Gary Simons",
    firstName: "Gary",
    lastName: "Simons",
    email: "gary@fantastic.tech",
    role: "Admin",
    date: "07/01/2025 18:45:01",
    sessions: "06/10/2025 07:23:46",
    permissions: "Admin",
    device: "Web",
    address: "Brighton, UK",
    createdAt: "09/20/2025 12:28:37",
  },
  {
    id: 7,
    name: "George Smeros",
    firstName: "George",
    lastName: "Smeros",
    email: "george@fantastic.tech",
    role: "Analyst",
    date: "07/18/2025 13:22:01",
    sessions: "09/22/2025 10:15:42",
    permissions: "Admin",
    device: "Web",
    address: "Brighton, UK",
    createdAt: "07/18/2025 08:32:34",
  },
  {
    id: 8,
    name: "Richard Smith",
    firstName: "Richard",
    lastName: "Smith",
    email: "admin@advancedcompliance.tech",
    role: "Analyst",
    date: "08/01/2025 02:45:29",
    sessions: "09/22/2025 10:45:12",
    permissions: "Admin",
    device: "Web",
    address: "Las Vegas, Nevada, USA",
    createdAt: "30/07/2025 09:09:34",
  },
  {
    id: 9,
    name: "Kerry Venner",
    firstName: "Kerry",
    lastName: "Venner",
    email: "kerry@fantastic.tech",
    role: "Analyst",
    date: "08/22/2025 17:54:21",
    sessions: "09/22/2025 11:32:50",
    permissions: "Admin",
    device: "Web",
    address: "Brighton, UK",
    createdAt: "08/20/2025 02:45:29",
  },
  {
    id: 10,
    name: "Mike Venner",
    firstName: "Mike",
    lastName: "Venner",
    email: "mike@fantastic.tech",
    role: "Compliance",
    date: "07/29/2025 12:34:51",
    sessions: "02/29/2025 23:12:45",
    permissions: "Regulator",
    device: "Web",
    address: "Brighton, UK",
    createdAt: "01/06/2025 04:45:56",
  },
  {
    id: 11,
    name: "Kenneth White",
    firstName: "Kenneth",
    lastName: "White",
    email: "kwhite.sports@gmail.com",
    role: "Analyst",
    date: "07/29/2025 12:34:51",
    sessions: "12/13/2025 19:25:37",
    permissions: "Analyst",
    device: "Web",
    address: "Las Vegas, Nevada, USA",
    createdAt: "04/05/2025 12:17:22",
  },
];

export function fetchUsers(): Promise<User[]> {
  return Promise.resolve(USER_MOCK);
}
